import { Currencies, WalletTypes } from '@constants/enums';
import { IWallet } from '@efex-services/client/types';

export const getCurrentWallet = (
  wallets: IWallet[],
  currency?: Currencies,
  walletType?: WalletTypes
) =>
  wallets?.find(
    (wallet) =>
      wallet.currency.name === currency &&
      wallet.wallet.wallet_type === walletType
  );

export default getCurrentWallet;
